<template>
  <div class="issued mr-bt-table-bf">
    <div style="padding-left:2%;padding-right:2%;">
      <section class="panel panel-default m-t-lg">
        <header class="panel-heading bg-light">
          <ul class="nav nav-tabs nav-justified">
            <li class="active">
              <a href="#box_application" data-toggle="tab" class="h4">
                <span class="text-dark">รายการใบคำขอ</span>
              </a>
            </li>
            <li>
              <a href="#box_uploadfile" data-toggle="tab" class="h4">
                <span class="text-dark">UPLOAD FILE</span>
              </a>
            </li>
            <li>
              <a href="#box_datamart" data-toggle="tab" class="h4">
                <span class="text-dark">Datamart Reprocess</span>
              </a>
            </li>
          </ul>
        </header>
        <div class="panel-body">
          <div class="tab-content">
            <div class="tab-pane active" id="box_application">
              <Table header="ข้อมูลใบคำขอ" :columns="column_table">
                <template slot="search">
                  <div class="col-lg-3 col-sm-6 col-xs-6 no-padd-m">
                    <div class="form-group">
                      <label class="col-lg-2 control-label m-t-xs h5">ชื่อ:</label>
                      <div class="col-lg-10">
                        <input type="text" class="form-control input-sm" v-model="first_name" />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-xs-6 no-padd-m">
                    <div class="form-group">
                      <label class="col-lg-3 control-label m-t-xs h5">นามสกุล:</label>
                      <div class="col-lg-9">
                        <input type="text" class="form-control input-sm" v-model="last_name" />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-sm-12 col-xs-12 m-t-xs no-padd-m">
                    <div class="form-group">
                      <label class="col-lg-2 col-xs-12 control-label m-t-xs h5">วันที่สร้าง:</label>
                      <div class="col-lg-4 col-xs-6">
                        <div class="input-group">
                          <DatePickerTH type="past" name="start_date" v-model="start_date" />
                          <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="col-lg-1 col-xs-1 text-center">
                        <span class="m-t-xs">-</span>
                      </div>
                      <div class="col-lg-4 col-xs-5">
                        <div class="input-group">
                          <DatePickerTH type="past" name="end_date" v-model="end_date" />
                          <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-xs-6 m-t-xs no-padd-m">
                    <div class="form-group">
                      <label class="col-lg-2 control-label m-t-xs h5">สถานะ:</label>
                      <div class="col-lg-10">
                        <select class="form-control" v-model="policy_status">
                          <option value="-1" disabled selected>กรุณาเลือกสถานะ</option>
                          <option value="0">ทั้งหมด</option>
                          <option value="1">รอชำระเงิน</option>
                          <option value="2">ออกกรมธรรม์</option>
                          <option value="3">เลยกำหนดชำระเงิน</option>
                          <option value="4">ยกเลิกใบคำขอ</option>
                          <option value="5">ขาดเอกสาร</option>
                          <option value="6">ยกเลิกกรมธรรม์</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-xs-6 m-t-xs no-padd-m">
                    <div class="form-group">
                      <label class="col-lg-4 control-label m-t-xs h5">ช่องทางชำระเงิน:</label>
                      <div class="col-lg-8">
                        <select class="form-control" v-model="channel_payment">
                          <option value="-1" disabled selected>กรุณาเลือกช่องทางชำระเงิน</option>
                          <option value="0">ทั้งหมด</option>
                          <option value="1">Bill Payment</option>
                          <option value="2">TMB Bank Account</option>
                          <option value="3">Credit Card</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-sm-6 col-xs-6 m-t-xs no-padd-m" v-if="group_type == 2">
                    <div class="form-group">
                      <label class="col-lg-4 control-label m-t-xs h5">เลขที่กลุ่ม:</label>
                      <div class="col-lg-8 ">
                        <input type="text" class="form-control" v-model="family_id" />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-sm-12 col-xs-12 m-t-xs no-padd-m text-center-m">
                    <button
                      type="button"
                      class="btn btn-default m-t-xs button-mt-sh10"
                      style="margin-left:20px;"
                      @click="searchReport()"
                    >
                      <i class="glyphicon glyphicon-search"></i> ค้นหาข้อมูล
                    </button>
                  </div>
                </template>

                <template slot="group">
                  <br /><br /><br /><br />
                  <ul class="nav nav-pills tab_panel clear">
                    <li class="active">
                      <a data-toggle="tab" href="#typePersonal" @click="group_type = 1" class>
                        <span class="text-dark"> ประเภทบุคคล </span>
                      </a>
                    </li>
                    <li>
                      <a data-toggle="tab" href="#typeGrop" @click="group_type = 2">
                        <span class="text-dark">ประเภทกลุ่ม</span>
                      </a>
                    </li>
                  </ul>
                </template>

                <template slot="main">
                  <tr v-if="group_type == 1" v-for="result in results" :key="result.applicationId">
                    <td>
                      <router-link :to="`/tvi/issued/${result.applicationId}`" target="_blank">
                        <i class="fa fa-address-book"></i>
                      </router-link>
                    </td>
                    <td>{{ result.applicationId }}</td>
                    <td>{{ result.firstName }} {{ result.lastName }}</td>
                    <td>{{ formatDockDateTimeTh(result.createdTime) }}</td>
                    <td>{{ result.paymentType }}</td>
                    <td
                      :class="{
                        'text-primary': statusPolicy(result.policyStatus) == 'ออกกรมธรรม์',
                        'text-danger': statusPolicy(result.policyStatus) == 'ยกเลิกใบคำขอ',
                        'text-info': statusPolicy(result.policyStatus) == 'รอชำระเงิน',
                      }"
                    >
                      {{ statusPolicy(result.policyStatus) }}
                    </td>
                    <td>
                      <div class="back-office-action-btn-group text-center">
                        <div
                          class="application-file-btn-container"
                          v-if="result.policyStatus === 1"
                        >
                          <router-link :to="`/tvi/issued/${result.applicationId}`" target="_blank">
                            <Button class="application-file-btn" type="info">
                              ไฟล์ใบคำขอ
                            </Button>
                          </router-link>
                        </div>
                        <div class="send-application-file-btn-container">
                          <Button
                            class="application-file-btn"
                            type="info"
                            @click.native="sendEmailApplication(result.applicationId)"
                          >
                            ส่งอีเมลไฟล์ใบคำขอ
                          </Button>
                        </div>
                        <div class="issued-policy-btn-container" v-if="result.policyStatus === 1">
                          <Button class="issued-policy-btn" @click.native="issuedPolicy(result)">
                            ออกกรมธรรม์
                          </Button>
                        </div>
                        <div
                          class="resend-sms-btn-container"
                          v-if="result.email && result.policyStatus === 2"
                        >
                          <Button
                            class="resend-sms-btn"
                            type="info"
                            theme="outline"
                            @click.native="resendPolicy(result)"
                          >
                            Re-send Policy
                          </Button>
                        </div>
                        <div
                          class="cancel-policy-btn-container"
                          v-if="result.policyStatus === 1 || result.policyStatus === 5"
                        >
                          <Button class="cancel-policy-btn" type="danger" data-toggle="dropdown">
                            ยกเลิกใบคำขอ <span class="caret"></span>
                          </Button>
                          <ul class="dropdown-menu">
                            <li
                              class="cancel-policy-menu"
                              v-for="reject_code in reject_codes"
                              :key="reject_code.pvId"
                              @click="confirmCancelPolicy(result.applicationId, reject_code)"
                            >
                              <a>{{ reject_code.description }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="group_type === 2" v-for="result in results" :key="result.familyId">
                    <td>
                      <router-link :to="`/tvi/issued/${result.applicationId}`" target="_blank">
                        <i class="fa fa-address-book"></i>
                      </router-link>
                    </td>
                    <td>{{ formatDockDateTimeTh(result.createdTime) }}</td>
                    <td>{{ result.familyId }}</td>
                    <td>{{ result.familyMembers }} คน</td>
                    <td>{{ result.applicationId }}</td>
                    <td>{{ result.firstName }} {{ result.lastName }}</td>
                    <td>{{ result.paymentType }}</td>
                    <td
                      :class="{
                        'text-primary': statusPolicy(result.policyStatus) == 'ออกกรมธรรม์',
                        'text-danger': statusPolicy(result.policyStatus) == 'ยกเลิกกรมธรรม์',
                        'text-info': statusPolicy(result.policyStatus) == 'รอชำระเงิน',
                      }"
                    >
                      {{ statusPolicy(result.policyStatus) }}
                    </td>
                    <td>
                      <div class="back-office-action-btn-group text-center">
                        <div
                          class="application-file-btn-container"
                          v-if="result.policyStatus === 1"
                        >
                          <router-link :to="`/tvi/issued/${result.applicationId}`" target="_blank">
                            <Button class="application-file-btn" type="info">
                              ไฟล์ใบคำขอ
                            </Button>
                          </router-link>
                        </div>
                        <div class="send-application-file-btn-container">
                          <Button
                            class="application-file-btn"
                            type="info"
                            @click.native="sendEmailApplication(result.applicationId)"
                          >
                            ส่งอีเมลไฟล์ใบคำขอ
                          </Button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="back-office-action-btn-group text-center">
                        <div class="issued-policy-btn-container" v-if="result.policyStatus === 1">
                          <Button class="issued-policy-btn" @click.native="issuedPolicy(result)">
                            ออกกรมธรรม์
                          </Button>
                        </div>
                        <div
                          class="resend-sms-btn-container"
                          v-if="result.email && result.policyStatus === 2"
                        >
                          <Button
                            class="resend-sms-btn"
                            type="info"
                            theme="outline"
                            @click.native="resendPolicy(result)"
                          >
                            Re-send Policy
                          </Button>
                        </div>
                        <div
                          class="cancel-policy-btn-container"
                          v-if="result.policyStatus === 1 || result.policyStatus === 5"
                        >
                          <Button class="cancel-policy-btn" type="danger" data-toggle="dropdown">
                            ยกเลิกใบคำขอ <span class="caret"></span>
                          </Button>
                          <ul class="dropdown-menu">
                            <li
                              class="cancel-policy-menu"
                              v-for="reject_code in reject_codes"
                              :key="reject_code.pvId"
                              @click="confirmCancelPolicy(result.applicationId, reject_code)"
                            >
                              <a>{{ reject_code.description }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="results.length">
                    <td colspan="12">
                      <div style="margin: 4em 0px;">{{ msg_error }}</div>
                    </td>
                  </tr>
                </template>

                <template v-show="results.length" slot="paginate">
                  <PaginateTable
                    v-model="pagination"
                    :page="pagination.page"
                    :per_page="pagination.per_page"
                    :last_page="pageNum"
                    :total="total"
                  />
                </template>
              </Table>
            </div>

            <div class="tab-pane" id="box_uploadfile">
              <div class="col-sm-12 b-r m-t-lg">
                <div class="form-group col-sm-12">
                  <label class="col-sm-3 control-label">
                    <i class="fa fa-cloud-upload"></i> UPLOAD FILE LICENSE
                  </label>
                  <div class="col-sm-3">
                    <input
                      type="file"
                      id="file"
                      ref="file"
                      accept=".xlsx, .xls"
                      v-on:change="handleFileUploadsImportUser()"
                    />
                  </div>
                  <div class="col-sm-1" v-if="res_file_import != null">
                    <span>
                      <i class="fa fa-check text-success" v-if="res_file_import == true"></i>
                      <i class="fa fa-times text-danger" v-else></i>
                    </span>
                  </div>
                  <div class="col-sm-2">
                    <button
                      class="btn btn-sm btn-success pull-right text-uc m-t-n-xs"
                      v-on:click="submitFilesImportUser()"
                      :disabled="disabled_upload_import"
                    >
                      <strong>UPLOAD FILE</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 b-r m-t-lg">
                <div class="form-group col-sm-12">
                  <label class="col-sm-3 control-label">
                    <i class="fa fa-cloud-upload"></i> UPLOAD FILE พนักงานลาออก
                  </label>
                  <div class="col-sm-3">
                    <input
                      type="file"
                      id="fileResign"
                      ref="fileResign"
                      accept=".xlsx, .xls"
                      class="filestyle"
                      data-icon="false"
                      data-classbutton="btn btn-default"
                      data-classinput="form-control inline input-s"
                      v-on:change="handleFileUploadsResignUser()"
                    />
                  </div>
                  <div class="col-sm-1" v-if="res_file_resign != null">
                    <span>
                      <i class="fa fa-check text-success" v-if="res_file_resign == true"></i>
                      <i class="fa fa-times text-danger" v-else></i>
                    </span>
                  </div>
                  <div class="col-sm-2">
                    <button
                      class="btn btn-sm btn-success pull-right text-uc m-t-n-xs"
                      v-on:click="submitFilesResignUser()"
                      :disabled="disabled_upload_resign"
                    >
                      <strong>UPLOAD FILE</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 b-r m-t-lg">
                <div class="form-group col-sm-12">
                  <label class="col-sm-3 control-label">
                    <i class="fa fa-cloud-upload"></i> MOVE พนักงาน
                  </label>
                  <div class="col-sm-3">
                    <input
                      type="file"
                      id="fileMove"
                      ref="fileMove"
                      accept=".xlsx, .xls"
                      class="filestyle"
                      data-icon="false"
                      data-classbutton="btn btn-default"
                      data-classinput="form-control inline input-s"
                      v-on:change="handleFileUploadsMoveUser()"
                    />
                  </div>
                  <div class="col-sm-1" v-if="res_file_move != null">
                    <span>
                      <i class="fa fa-check text-success" v-if="res_file_move == true"></i>
                      <i class="fa fa-times text-danger" v-else></i>
                    </span>
                  </div>
                  <div class="col-sm-2">
                    <button
                      class="btn btn-sm btn-success pull-right text-uc m-t-n-xs"
                      v-on:click="submitFilesMoveUser()"
                      :disabled="disabled_upload_move"
                    >
                      <strong>UPLOAD FILE</strong>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="box_datamart">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="col-sm-2 control-label h5">PV file dates</label>
                    <div class="col-sm-10">
                      <textarea class="form-control" rows="5" v-model="pv_file_dates"></textarea>
                    </div>
                    <div class="col-sm-12">
                      <h5 class="text-danger h5 m-t-md">
                        ตัวอย่างการใส่ข้อมูล: 2019-08-07, 2019-08-08
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 m-t">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="col-sm-2  h5">Dates to zip</label>
                    <div class="col-sm-10">
                      <textarea class="form-control" rows="5" v-model="dates_to_zip"></textarea>
                    </div>
                    <div class="col-sm-12">
                      <h5 class="text-danger h5 m-t-md">
                        ตัวอย่างการใส่ข้อมูล: 2019-08-07, 2019-08-08
                      </h5>
                    </div>
                    <button
                      type="button"
                      class="btn btn-success pull-right m-t"
                      @click="reprocessDatamart()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

import Table from '@/components/Table/Index'
import PaginateTable from '@/components/Table/PaginateTable'
import DatePickerTH from '@/components/Form/DatePickerTH'
import ModalUpload from '@/components/Modal/ModalUpload'
import Button from '@/components/Button'
import API from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  name: 'issued',
  data() {
    return {
      columns: {
        type_personal: [
          '',
          'เลขที่ใบคำขอ',
          'ชื่อ - สกุล',
          'วันที่ทำรายการ',
          'ช่องทางชำระเงิน',
          'สถานะ',
          '',
        ],
        type_group: [
          '',
          'วัน-เวลา',
          'เลขที่กลุ่ม',
          'จำนวนคน',
          'เลขที่ใบคำขอ',
          'ชื่อ - สกุล',
          'ช่องทางชำระเงิน',
          'สถานะ',
          'การดำเนินการ',
          'จัดการกรมธรรม์',
        ],
      },
      column_table: null,
      group_type: 1,
      from_component: '',
      policy_status: -1,
      channel_payment: -1,
      family_id: '',
      pagination: {
        page: 1,
        per_page: 20,
      },
      pageNum: 0,
      total: 0,
      results: [],
      reject_codes: [],
      disabled_upload_import: true,
      disabled_upload_resign: true,
      disabled_upload_move: true,
      fileImport: null,
      fileResign: null,
      fileMove: null,
      res_file_import: null,
      res_file_resign: null,
      res_file_move: null,
      pv_file_dates: null,
      dates_to_zip: null,
      msg_error: '',
      first_name: null,
      last_name: null,
      start_date: null,
      end_date: null,
    }
  },
  watch: {
    pagination(val) {
      this.init()
    },
    getResFileImport() {
      this.res_file_import = this.resFileLicenseImport
    },
    getResFileResign() {
      this.res_file_resign = this.resFileLicenseResign
    },
    getResFileMove() {
      this.res_file_move = this.resFileLicenseMove
    },
    group_type(val) {
      this.searchReport()
    },
  },
  computed: {
    ...mapGetters([
      'statusPolicy',
      'env',
      'formatDockDateTimeTh',
      'numberWithCommas',
      'resFileLicenseImport',
      'resFileLicenseResign',
      'resFileLicenseMove',
    ]),
    getResFileImport() {
      return this.resFileLicenseImport
    },
    getResFileResign() {
      return this.resFileLicenseResign
    },
    getResFileMove() {
      return this.resFileLicenseMove
    },
  },
  components: {
    Button,
    Table,
    PaginateTable,
    ModalUpload,
    DatePickerTH,
  },
  mounted() {
    this.getRejectCodes()
    this.init()
  },
  methods: {
    ...mapActions([
      'api_get_file_application',
      'api_upload_file_import_user',
      'api_upload_file_resign_user',
      'api_upload_file_move_user',
    ]),
    searchReport() {
      this.pagination.page = 1
      this.init()
    },
    columnTable() {
      if (this.group_type == 1) {
        this.column_table = this.columns.type_personal
      } else {
        this.column_table = this.columns.type_group
      }
    },
    init() {
      const CALL_API = this.env.VUE_APP_PATH_API
      const CALL_SERVICE = this.group_type == 1 ? 'report-application' : 'family-report-application'

      this.columnTable()

      var params = {
        start_date: '2019-06-02',
        end_date: '2050-12-31',
        page: this.pagination.page,
        per_page: this.pagination.per_page,
      }

      if (this.start_date != null) {
        params.start_date = this.start_date.origin
      }

      if (this.end_date != null) {
        params.end_date = this.end_date.origin
      }

      if (this.policy_status > 0) {
        params.policy_status = this.policy_status
      }
      if (this.channel_payment > 0) {
        params.payment_method = this.channel_payment
      }
      if (this.family_id != '') {
        params.family_id = this.family_id
      }

      //search firstname and lastname
      if (this.first_name != null) {
        params.first_name = this.first_name
      }
      if (this.last_name != null) {
        params.last_name = this.last_name
      }

      this.$http
        .get(`${CALL_API}${CALL_SERVICE}`, {
          params: params,
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        })
        .then(
          response => {
            this.results = response.body.result.report
            this.pageNum = response.body.result.pageNum
            this.total = response.body.result.total
          },
          response => {
            if (
              response.body.statusCode == 400 &&
              response.body.message == 'Invalid data from db'
            ) {
              this.results = []
              this.msg_error = 'ไม่พบข้อมูล'
            } else {
              this.results = []
              this.msg_error = 'เกิดข้อผิดพลาด'
            }
          },
        )
    },
    getFile(application_id) {
      this.api_get_file_application(application_id)
    },
    whatPaymentMethod(val) {
      if (val == 1) {
        return 'บิล'
      } else if (val == 2) {
        return 'บัตรเครดิต'
      } else if (val == 3) {
        return 'บัญชีธนาคาร'
      }
    },
    whatStatus(val) {
      switch (val) {
        case 0:
          return 'ขาดเอกสาร'
          break
        case 1:
          return 'รอชำระเงิน'
          break
        case 2:
          return 'ออกกรมธรรม์'
          break
        case 3:
          return 'เลยกำหนดชำระเงิน'
          break
        case 4:
          return 'ยกเลิกใบคำขอ'
          break
        default:
          return '???'
      }
    },
    issuedPolicy(result) {
      this.$swal({
        title: 'ต้องการออกกรมธรรม์?',
        text: result.applicationId,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(res => {
        if (res.value) {
          this.generatePolicy(result)
        }
      })
    },
    sendEmailApplication(applicationId) {
      try {
        const CALL_API = this.env.VUE_APP_PATH_API
        this.$http
          .post(
            `${CALL_API}api/v1/application/application-send-email/${applicationId}`,
            {},
            {
              headers: {
                ...generateAuthorizationRequestHeader(),
              },
            },
          )
          .then(
            response => {
              this.$swal({
                type: 'success',
                title: `ระบบได้ส่งอีเมลใบคำขอเลขที่ ${applicationId} เรียบร้อยแล้ว`,
              })
            },
            error => {
              this.$swal({
                type: 'error',
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
              })
            },
          )
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
        })
      }
    },
    resendSms({ applicationId, firstname, lastname }) {
      this.$swal({
        title: `Confirm to re-send Digital Care Card to ${firstname} ${lastname}`,
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          try {
            this.$swal({
              title: 'Re-Sending Digital Care Card SMS',
              html: '<h5 class="m-b-md">....</h5><div class="loader"></div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            })

            const CALL_API = this.env.VUE_APP_PATH_API
            this.$http
              .post(
                `${CALL_API}resend-dcc-sms/${applicationId}`,
                {},
                {
                  headers: {
                    ...generateAuthorizationRequestHeader(),
                  },
                },
              )
              .then(response => {
                let res = response.body
                //console.log(res);
                if (res.statusCode == 200 && res.result.smsSendingStatus === true) {
                  this.init()
                  this.$swal({
                    type: 'success',
                    title: 'Resent Digital Care Card succesfully.',
                  })
                } else {
                  this.$swal({
                    type: 'error',
                    title: 'Unable to Resend Digital Care Card. Please try again.',
                  })
                }
              })
          } catch (error) {
            //console.log("try catch");
            //console.log(error);
          }
        }
      })
    },
    getRejectCodes(result) {
      try {
        const CALL_API = this.env.VUE_APP_PATH_API
        this.$http
          .get(`${CALL_API}reject-codes`, {
            headers: {
              ...generateAuthorizationRequestHeader(),
            },
          })
          .then(response => {
            this.reject_codes = response.body.result.code
          })
      } catch (error) {
        //console.log("try catch");
        //console.log(error);
      }
    },
    generatePolicy({ applicationId, titleDesc, firstName, lastName }) {
      this.$swal({
        title: 'กรุณารอสักครู่',
        html: '<h5 class="m-b-md">กำลังทำการออกกรมธรรม์</h5><div class="loader"></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
      })

      this.$http
        .post(
          API.DOCUMENTS.GENERATE_POLICY(applicationId),
          {},
          {
            headers: {
              ...generateAuthorizationRequestHeader(),
            },
          },
        )
        .then(res => res.json())
        .then(
          response => {
            this.$swal({
              type: 'success',
              title: `ระบบ PV ได้ออกกรมธรรม์ให้กับ <br /> ${titleDesc}${firstName} ${lastName} <br /> เลขที่ใบคำขอ ${applicationId} เรียบร้อยแล้ว`,
            })

            this.init()
          },
          error => {
            this.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            })
          },
        )
    },
    confirmCancelPolicy(applicationId, { description: rejectReason, pvId }) {
      this.$swal({
        title: 'ต้องการยกเลิกใบคำขอ?',
        text: `เลขที่ ${applicationId} เพราะ ${rejectReason}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.value) {
          this.cancelPolicy(applicationId, pvId)
        }
      })
    },
    cancelPolicy(applicationId, pvId) {
      try {
        const CALL_API = this.env.VUE_APP_PATH_API
        this.$http
          .post(
            `${CALL_API}cancel-policy/${applicationId}/${pvId}`,
            {},
            {
              headers: {
                ...generateAuthorizationRequestHeader(),
              },
            },
          )
          .then(response => {
            let res = response.body
            //console.log(res);

            if (res.statusCode == 200) {
              this.init()
            } else {
            }
          })
      } catch (error) {
        //console.log("try catch");
        //console.log(error);
      }
    },
    handleFileUploadsImportUser() {
      this.fileImport = this.$refs.file.files[0]
      this.disabled_upload_import = false
    },
    submitFilesImportUser() {
      let data = {
        name: 'file',
        filename: this.fileImport,
      }
      this.$swal({
        title: 'ยืนยันที่ต้องการ upload file license \nfile name: ' + this.fileImport.name,
        type: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.api_upload_file_import_user(data)
        }
      })
    },
    handleFileUploadsResignUser() {
      this.fileResign = this.$refs.fileResign.files[0]
      this.disabled_upload_resign = false
    },
    submitFilesResignUser() {
      let data = {
        name: 'file',
        filename: this.fileResign,
      }
      this.$swal({
        title: 'ยืนยันที่ต้องการ upload file พนักงานลาออก \nfile name: ' + this.fileResign.name,
        type: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.api_upload_file_resign_user(data)
        }
      })
    },
    handleFileUploadsMoveUser() {
      this.fileMove = this.$refs.fileMove.files[0]
      //console.log("fileMove", this.fileMove);
      this.disabled_upload_move = false
    },
    submitFilesMoveUser() {
      //console.log("up3");
      let data = {
        name: 'file',
        filename: this.fileMove,
      }
      this.$swal({
        title: 'ยืนยันที่ต้องการ upload file ย้ายพนักงาน \nfile name: ' + this.fileMove.name,
        type: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.api_upload_file_move_user(data)
        }
      })
    },
    reprocessDatamart() {
      const data = {
        pvFileDates: this.pv_file_dates.split(',').map(d => d.trim()),
        datesToZip: this.dates_to_zip.split(',').map(d => d.trim()),
      }

      this.$swal({
        title: 'Confirm to re-proceed Datamart as',
        type: 'info',
        html:
          '<h5>PV Files Dates: ' +
          data.pvFileDates.join(',') +
          '</h5>' +
          '<h5>Dates to Zip: ' +
          data.datesToZip.join(',') +
          '</h5>',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          try {
            this.$swal({
              title: 'Re-Proceeding Datamart',
              html: '<h5 class="m-b-md">....</h5><div class="loader"></div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            })

            const CALL_API = this.env.VUE_APP_PATH_API
            this.$http
              .post(
                `${CALL_API}datamart-reproceed`,
                {
                  pvFileDates: data.pvFileDates,
                  datesToZip: data.datesToZip,
                },
                {
                  headers: {
                    ...generateAuthorizationRequestHeader(),
                  },
                },
              )
              .then(response => {
                let res = response.body
                //console.log(res);
                if (res.statusCode == 200 && res.result.uploadStatus === true) {
                  this.init()
                  this.$swal({
                    type: 'success',
                    title: 'Reproceeded datamart succesfully.',
                  })
                } else {
                  this.$swal({
                    type: 'error',
                    title: 'Unable to reproceed datamart. Please try again.',
                  })
                }
              })
          } catch (error) {
            //console.log("try catch");
            //console.log(error);
          }
        }
      })
    },
    resendPolicy({ applicationId, titleDesc, firstName, lastName }) {
      this.$swal({
        title: `Confirm to re-send Digital Care Card to ${firstName} ${lastName}`,
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: 'กรุณารอสักครู่',
            html: '<h5 class="m-b-md">กำลังทำการส่งอีเมล</h5><div class="loader"></div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          })

          this.$http
            .post(
              API.DOCUMENTS.SEND_EMAIL_POLICY(applicationId),
              {},
              {
                headers: {
                  ...generateAuthorizationRequestHeader(),
                },
              },
            )
            .then(res => res.json())
            .then(
              response => {
                this.$swal({
                  type: 'success',
                  title: `ระบบได้ส่งอีเมลกรรมธรรม์ให้กับ <br /> ${titleDesc}${firstName} ${lastName} <br /> เลขที่ใบคำขอ ${applicationId} เรียบร้อยแล้ว`,
                })
              },
              error => {
                this.$swal({
                  type: 'error',
                  title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                })
              },
            )
        }
      })
    },
  },
}
</script>

<style lang="scss">
.back-office-action-btn-group {
  .application-file-btn-container,
  .send-application-file-btn-container,
  .send-quotation-btn-container,
  .issued-policy-btn-container,
  .resend-sms-btn-container,
  .cancel-policy-btn-container {
    margin-bottom: 8px;
  }

  .cancel-policy-btn-container {
    .cancel-policy-menu {
      cursor: pointer;
    }
  }
}
</style>
